import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import AccountActions from 'actions/AccountActions';
import {Record} from 'immutable';

const State = Record({
  hasSalesforce: undefined,
  hasSalesforceLoading: false,
  hasSalesforceError: false,
  hasSalesforceLoaded: false,
  createdDate: undefined,
  createdDateLoading: false,
  createdDateFetched: false,
  hasSlack: false,
  hasSlackLoaded: false,
});

@immutableStore
class AccountStore {
  constructor() {
    this.state = State();
    this.bindActions(AccountActions);
  }

  hasSlack() {
    this.setState({
      hasSlackLoaded: false,
    });
  }

  hasSlackSuccess(hasSlack) {
    this.setState({
      hasSlack,
      hasSlackLoaded: true,
    });
  }

  hasSlackError(error) {
    console.error(error);
    this.setState({
      hasSlackLoaded: false,
    });
  }

  fetchCreatedDate() {
    this.setState({createdDateLoading: true});
  }

  fetchCreatedDateSuccess(createdDate) {
    this.setState({
      createdDate,
      createdDateLoading: false,
      createdDateFetched: true,
    });
  }

  fetchCreatedDateError() {
    this.setState({
      createdDateLoading: false,
      createdDate: undefined,
    });
  }

  accountHasSalesforce() {
    this.setState({
      hasSalesforce: undefined,
      hasSalesforceLoading: true,
      hasSalesforceError: false,
    });
  }

  accountHasSalesforceSuccess(hasSalesforce) {
    if (!hasSalesforce) {
      console.warn('This account does not have a salesforce crm.');
      console.warn('We will not show CRM options (create rule by opportunity, etc)');
    }

    this.setState({
      hasSalesforce,
      hasSalesforceError: false,
      hasSalesforceLoading: false,
      hasSalesforceLoaded: true,
    });
  }

  accountHasSalesforceError() {
    this.setState({
      hasSalesforce: undefined,
      hasSalesforceLoading: false,
      hasSalesforceError: true,
    });
  }
}

export default alt.createStore(AccountStore);
